import { create } from "zustand";
import * as Models from "../Models";
import * as fromAzureApi from "../Api/azure";
import { AxiosResponse } from "axios";
import { CUSTOMERS_TREE, SITE_TREE, TYPE_SITE } from "../Constants";
import { pushTo } from "../Helpers/links";
import _ from "lodash";
import filterItemsStore from "./filterItems";

type salesInfoState = {
  // isCountrySearch: boolean;
  mobileSearchOpen: boolean;
  mobileMenuOpen: boolean;
  adminMenuActive: boolean;
  toggleMobileSearch?: () => void;
  mobileOverLayClose: () => void;
  toggleMobileMenu: () => void;
  toggleAdminMenu: (show: boolean) => void;
};

const salesInfoStore = create<salesInfoState>((set, get) => ({
  // isCountrySearch: false,
  mobileMenuOpen: false,
  mobileSearchOpen: false,
  adminMenuActive: false,
  filesReadySendState: [],
  toggleMobileSearch: () => {
    set((state) => ({
      mobileSearchOpen: !state.mobileSearchOpen,
      mobileMenuOpen: false,
    }));
  },

  mobileOverLayClose: () => {
    set({
      mobileSearchOpen: false,
      mobileMenuOpen: false,
      adminMenuActive: false,
    });
  },

  toggleMobileMenu: () => {
    set((state) => ({
      mobileMenuOpen: !state.mobileMenuOpen,
      mobileSearchOpen: false,
    }));
  },

  toggleAdminMenu: (show: boolean) => {
    set({ adminMenuActive: show });
  },
}));

export default salesInfoStore;
